<template lang="pug">
.filter
  form(@submit.prevent="onFilter")
    modal(:active="true", title="Filtros dos cadastros", @close="close")
      div(slot="modal-body")
        .columns
          .column.col-6
            form-group(label="Tipo de cadastro")
              select.form-select(v-model="q.tipo_eq")
                option(value="") Todos
                option(v-for="(tipo, key) in cadastroTipos", :value="key") {{ tipo }}
          .column.col-6
            form-group(:label="'db.models.cadastro' | translate")
              input.form-input(
                v-model="q.numero_eq",
                :placeholder="'cadastro.numero' | tModel"
              )
          .column.col-4
            form-group(:label="'cadastro.zona' | tModel")
              input.form-input(
                v-model="q.zona_eq",
                :placeholder="'cadastro.zona' | tModel"
              )
          .column.col-4
            form-group(:label="'cadastro.quadra' | tModel")
              input.form-input(
                v-model="q.quadra_eq",
                :placeholder="'cadastro.quadra' | tModel"
              )
          .column.col-4
            form-group(:label="'cadastro.lote' | tModel")
              input.form-input(
                v-model="q.lote_eq",
                :placeholder="'cadastro.lote' | tModel"
              )
      .float-right(slot="modal-footer")
        a.btn.btn-link.btn-lg.text-gray(@click="clearFilter", v-if="filtered") Limpar filtros
        button.btn.btn-primary.btn-lg Filtrar
</template>

<script>
import filterMixin, { defaultStoreImports } from "@/mixins/filter";

export default {
  vuex: { cadastros: defaultStoreImports },
  mixins: [filterMixin],
  data() {
    return { q: { tipo_eq: "" } };
  },
  computed: {
    cadastroTipos() {
      return this.$i18n.t("enums.cadastro.tipo");
    },
  },
};
</script>
